import React from 'react';
import { useI18n } from 'next-localization';

type Props = {
  document: {
    documentType: string;
    documentURI: string;
    title: string;
  };
};

const FundsExternalLink: React.FC<Props> = ({ document }) => {
  const { t } = useI18n();
  return (
    <a href={document.documentURI} target="_blank" title={document.title} className="btn-naked btn">
      <i className="bi bi-box-arrow-up-right icon-external" />
      <span className="sr-only">{t('opensInNewWindow')}</span>
    </a>
  );
};

export default FundsExternalLink;
